import {apiClient} from "@/state/modules/apiClient";
const controller = "Sync";

export const actions = {
    async getAllLinhVuc({commit}, value) {
        return apiClient.get(controller + "/get-Linh-Vuc/" + value );
    },

    async getAllDonVi({commit}, value) {
        console.log("LOG SYNC STORE ")
        return apiClient.get(controller + "/get-Don-Vi");
    },

    async getAllMucDo({commit}, value) {
        return apiClient.get(controller + "/get-Muc-Do");
    },
    async getPagingParams({commit}, params) {
        return apiClient.post(controller +"/get-paging-params", params);
    },

    async getPagingParamsDV({commit}, params) {
        return apiClient.post(controller +"/get-paging-Don-Vi", params);
    },

    async getPagingParamsLV({commit}, params) {
        return apiClient.post(controller +"/get-paging-Linh-Vuc", params);
    },

    async getById({commit}, values) {
        return apiClient.get(controller +"/get-question-by-id/" + values);
    },
};
